import type { MenuItem } from "../menu.type";

import { useNavigationActionLogout } from "@/modules/navigation";

export const useMenuItemLogoutAction = (): MenuItem => {
  const { key, text, icon, runAction } = useNavigationActionLogout();

  return {
    key: `${key}-action`,
    label: text,
    icon,
    onClick: runAction,
  };
};
